import React, { useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect } from "react";
import "./admin.css";
import ReservationsTable from "./../../components/reservationsTable/ReservationsTable";
import ReservationForm from "./../../components/reservationForm/ReservationForm";
import { EMPLOYEE_ENUM, getEmployee } from "../../models/employees";
import EmployeeSelect from "../../components/employeeSelect/employeeeSelect";

export const Admin = () => {
  const [editingReservation, setEditingReservation] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(
    getEmployee(EMPLOYEE_ENUM.Sam),
  );
  const [showForm, setShowForm] = useState(false);
  const [reservations, setReservations] = useState([]);

  const fetchReservations = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL_FETCHADMIN}?employeeId=${selectedEmployee.id}`,
      )
      .then((response) => {
        const filteredData = response.data
          // TODO: NÍŽE JE KÓD PRO ODEBRÁNÍ HISTORICKÝCH ZÁZNAMŮ.
          // .filter((item) => {
          //   const itemDate = dayjs(item.datum).format("YYYY-MM-DD");
          //   return filterDate ? itemDate === filterDate : itemDate >= today;
          // })
          .map((item) => {
            // Convert date format for display
            return {
              ...item,
              zacatek_cas: dayjs(item.zacatek_cas, "HH:mm:ss").format("HH:mm"),
              konec_cas: dayjs(item.konec_cas, "HH:mm:ss").format("HH:mm"),
            };
          });

        setReservations(filteredData);
      })
      .catch((error) => console.error("Failed to fetch data:", error));
  };
  useEffect(() => {
    fetchReservations(selectedEmployee.id);
  }, [selectedEmployee]);

  const handleEdit = (reservation) => {
    setEditingReservation(reservation);
    setShowForm(true); // Show form with data to edit
  };

  const handleAddNew = () => {
    setEditingReservation(null); // Clear any existing data
    setShowForm(true); // Show empty form for new reservation
  };

  const handleSave = (formData) => {
    console.log("formData.id: ", formData.id);
    const method = formData.id ? "put" : "post";
    const url = formData.id
      ? `${process.env.REACT_APP_API_URL_EDIT}?id=${formData.id}` // Assuming edit.php handles updates
      : process.env.REACT_APP_API_URL_SUBMIT;

    axios[method](url, formData)
      .then(() => {
        setShowForm(false); // Hide form after save
        fetchReservations(); // Refetch data after save
        console.log("Data saved successfully");
        // You may want to refresh or update data in your table here
      })
      .catch((error) => console.error("Failed to save data:", error));
  };

  const confirmDelete = (reservationId) => {
    if (window.confirm("Opravdu chcete smazat tuto rezervaci?")) {
      deleteReservation(reservationId);
    }
  };

  const deleteReservation = (reservationId) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL_DELETE}?id=${reservationId}`)
      .then(() => {
        console.log("Deleted successfully");
        // Refresh data or adjust state here, for example:
        fetchReservations();
      })
      .catch((error) => console.error("Failed to delete:", error));
  };

  const handleCancel = () => {
    setShowForm(false); // Hide the form when cancel is clicked
  };

  return (
    <div className="admin">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <EmployeeSelect
          style={{ padding: "6px 20px", marginRight: "10px" }}
          selectedEmployee={selectedEmployee}
          onSelectedEmployee={setSelectedEmployee}
        />
        <button className="add" onClick={handleAddNew}>
          Vytvořit novou rezervaci
        </button>
      </div>
      <ReservationsTable
        data={reservations}
        onEdit={handleEdit}
        onDelete={confirmDelete}
      />
      {showForm && (
        <ReservationForm
          reservation={editingReservation}
          onSave={handleSave}
          onCancel={handleCancel}
          selectedEmployee={selectedEmployee}
        />
      )}
    </div>
  );
};
